import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/closeup-hands-passing-contract-unrecognizable-businessman_1098-19612.jpg';

function VeteransBenefitsClaims() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Veterans' Benefits and Claims Assistance" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Veterans' Benefits and Claims Assistance</h4>
              <p>
                This sub-department is dedicated to assisting veterans in accessing and understanding their entitled benefits and claims.<br />
                Services include guidance on pension applications, disability claims, and educational benefits.<br /><br />
                By streamlining the claims process and providing personalized support, we aim to ensure veterans receive the benefits they deserve.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Assistance with Disability Claims</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Guidance on Pension Applications</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Support for Educational Benefit Access</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are dedicated to ensuring that veterans and their families can navigate the benefits system effectively, receiving the support and recognition they have earned.
              </p>
            </div>
            <div>
              <Link to="/department/veterans">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default VeteransBenefitsClaims;
